import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { IdealForNotice } from './IdealForNotice';
import { KeyHighlights } from './KeyHighlights';
import { PrerequisiteWarning } from './PrerequisiteWarning';
import { RegistrationCallout } from './RegistrationCallout';
import { CourseGoal } from './CourseGoal';
import { CourseOverview } from './CourseOverview';
import { CourseSchedule } from './CourseSchedule';
import { WhatToBring } from './WhatToBring';
import { CourseCosts } from './CourseCosts';
import { ContactSection } from './ContactSection';
import { QuickLinks } from './QuickLinks';
export function PersonalProtectionPage() {
  return <PageLayout data-id="element-2374">
      <HeaderBanner data-id="element-2375" />
      <IdealForNotice data-id="element-2376" />
      <KeyHighlights data-id="element-2377" />
      <PrerequisiteWarning data-id="element-2378" />
      <RegistrationCallout data-id="element-2379" />
      <CourseGoal data-id="element-2380" />
      <CourseOverview data-id="element-2381" />
      <CourseSchedule data-id="element-2382" />
      <WhatToBring data-id="element-2383" />
      <CourseCosts data-id="element-2384" />
      <ContactSection data-id="element-2385" />
      <QuickLinks data-id="element-2386" />
    </PageLayout>;
}